/**
 * Stable CSS class names for E2E — pages_ru/Cargo (CargoShippingFeeManagement).
 * Covers the page, the filter drawer, the edit drawer, and the confirm dialog.
 * Containers use `cargo-shipping-fee__<element>`; inputs and user-interactable
 * controls use `cargo-shipping-fee-input--<name>`.
 */
export const CSF = {
    page: 'cargo-shipping-fee-page',
    root: 'cargo-shipping-fee',

    /* --- Page header / toolbar ----------------------------------------- */
    breadcrumb: 'cargo-shipping-fee__breadcrumb',
    loading: 'cargo-shipping-fee__loading',
    body: 'cargo-shipping-fee__body',
    subheaderBox: 'cargo-shipping-fee__subheader-box',
    subheader: 'cargo-shipping-fee__subheader',
    toolbarSpacer: 'cargo-shipping-fee__toolbar-spacer',
    toolbarActions: 'cargo-shipping-fee__toolbar-actions',
    btnOpenFilter: 'cargo-shipping-fee-input--button-open-filter',
    btnExportExcel: 'cargo-shipping-fee-input--button-export-excel',
    btnImportExcel: 'cargo-shipping-fee-input--button-import-excel',
    btnImportTrigger: 'cargo-shipping-fee-input--button-import-trigger',
    inputImportFile: 'cargo-shipping-fee-input--import-file',

    chipsBox: 'cargo-shipping-fee__chips-box',
    chipsPaper: 'cargo-shipping-fee__chips-paper',
    chipItem: 'cargo-shipping-fee__chip-item',
    chip: 'cargo-shipping-fee__chip',

    grid: 'cargo-shipping-fee__grid',

    /* --- Grid cells ---------------------------------------------------- */
    cellId: 'cargo-shipping-fee__cell-id',
    cellStatus: 'cargo-shipping-fee__cell-status',
    inputCellStatusSwitch: 'cargo-shipping-fee-input--cell-status-switch',
    cellRegion: 'cargo-shipping-fee__cell-region',
    cellCargoCompany: 'cargo-shipping-fee__cell-cargo-company',
    cellDeliveryType: 'cargo-shipping-fee__cell-delivery-type',
    cellShoppingAmount: 'cargo-shipping-fee__cell-shopping-amount',
    cellShipmentFee: 'cargo-shipping-fee__cell-shipment-fee',
    cellCondition: 'cargo-shipping-fee__cell-condition',
    cellRuleTemplateId: 'cargo-shipping-fee__cell-rule-template-id',
    cellActions: 'cargo-shipping-fee__cell-actions',
    btnRowMenu: 'cargo-shipping-fee-input--button-row-menu',
    rowMenu: 'cargo-shipping-fee__row-menu',
    rowMenuItem: 'cargo-shipping-fee__row-menu-item',
    rowMenuItemEdit: 'cargo-shipping-fee__row-menu-item--edit',
    rowMenuItemDelete: 'cargo-shipping-fee__row-menu-item--delete',

    /* --- Empty state (initial region picker) --------------------------- */
    emptyState: 'cargo-shipping-fee__empty-state',
    emptyInfo: 'cargo-shipping-fee__empty-info',
    emptyImage: 'cargo-shipping-fee__empty-image',
    emptyText: 'cargo-shipping-fee__empty-text',
    emptyForm: 'cargo-shipping-fee__empty-form',
    emptyRegionField: 'cargo-shipping-fee__empty-region-field',
    inputEmptyRegion: 'cargo-shipping-fee-input--empty-region',
    regionMenuItem: 'cargo-shipping-fee__region-menu-item',
    emptyFilterAction: 'cargo-shipping-fee__empty-filter-action',
    btnEmptyFilter: 'cargo-shipping-fee-input--button-empty-filter',
    emptyDetailedAction: 'cargo-shipping-fee__empty-detailed-action',
    btnEmptyDetailed: 'cargo-shipping-fee-input--button-empty-detailed',

    /* --- Filter drawer ------------------------------------------------- */
    filterDrawer: 'cargo-shipping-fee__filter-drawer',
    filterForm: 'cargo-shipping-fee__filter-form',
    filterContainer: 'cargo-shipping-fee__filter-container',
    filterHeader: 'cargo-shipping-fee__filter-header',
    filterFieldRegion: 'cargo-shipping-fee__filter-field-region',
    inputFilterRegion: 'cargo-shipping-fee-input--filter-region',
    filterRegionOption: 'cargo-shipping-fee__filter-region-option',
    filterFieldCargoCompany: 'cargo-shipping-fee__filter-field-cargo-company',
    inputFilterCargoCompany: 'cargo-shipping-fee-input--filter-cargo-company',
    filterCargoCompanyOption: 'cargo-shipping-fee__filter-cargo-company-option',
    filterFieldDeliveryType: 'cargo-shipping-fee__filter-field-delivery-type',
    inputFilterDeliveryType: 'cargo-shipping-fee-input--filter-delivery-type',
    filterDeliveryTypeOption: 'cargo-shipping-fee__filter-delivery-type-option',
    filterFieldShoppingAmount: 'cargo-shipping-fee__filter-field-shopping-amount',
    inputFilterShoppingAmount: 'cargo-shipping-fee-input--filter-shopping-amount',
    filterFieldStatus: 'cargo-shipping-fee__filter-field-status',
    inputFilterStatus: 'cargo-shipping-fee-input--filter-status',
    filterStatusOption: 'cargo-shipping-fee__filter-status-option',
    filterActionsBox: 'cargo-shipping-fee__filter-actions-box',
    btnFilterSubmit: 'cargo-shipping-fee-input--button-filter-submit',

    /* --- Edit drawer --------------------------------------------------- */
    editDrawer: 'cargo-shipping-fee__edit-drawer',
    editForm: 'cargo-shipping-fee__edit-form',
    editContainer: 'cargo-shipping-fee__edit-container',
    editHeader: 'cargo-shipping-fee__edit-header',
    editInfoRow: 'cargo-shipping-fee__edit-info-row',
    editInfoCargoCompany: 'cargo-shipping-fee__edit-info--cargo-company',
    editInfoDeliveryType: 'cargo-shipping-fee__edit-info--delivery-type',
    editFieldsBox: 'cargo-shipping-fee__edit-fields-box',
    editFieldShoppingAmount: 'cargo-shipping-fee__edit-field-shopping-amount',
    inputEditShoppingAmount: 'cargo-shipping-fee-input--edit-shopping-amount',
    editFieldShipmentFee: 'cargo-shipping-fee__edit-field-shipment-fee',
    inputEditShipmentFee: 'cargo-shipping-fee-input--edit-shipment-fee',
    editFieldCondition: 'cargo-shipping-fee__edit-field-condition',
    inputEditCondition: 'cargo-shipping-fee-input--edit-condition',
    editConditionOption: 'cargo-shipping-fee__edit-condition-option',
    editActionsBox: 'cargo-shipping-fee__edit-actions-box',
    btnEditSubmit: 'cargo-shipping-fee-input--button-edit-submit',

    /* --- Confirm dialog ------------------------------------------------ */
    confirmDialog: 'cargo-shipping-fee__confirm-dialog',
    confirmDialogLoading: 'cargo-shipping-fee__confirm-dialog-loading',
    confirmDialogTitle: 'cargo-shipping-fee__confirm-dialog-title',
    confirmDialogContent: 'cargo-shipping-fee__confirm-dialog-content',
    confirmDialogContentText: 'cargo-shipping-fee__confirm-dialog-content-text',
    confirmDialogActions: 'cargo-shipping-fee__confirm-dialog-actions',
    btnConfirmReject: 'cargo-shipping-fee-input--button-confirm-reject',
    btnConfirmAccept: 'cargo-shipping-fee-input--button-confirm-accept',
} as const;

export const csfCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
